import { Container, Typography, Box } from '@mui/material';
import { css } from '@emotion/css';
import BusinessHours from '../components/BusinessHours';
import LocationClosures from '../components/LocationClosures';

const SettingsPage = () => {
  return (
    <Container
      className={css`
        padding-top: 2rem;
        padding-bottom: 2rem;
      `}
    >
      <Box className={headerStyles}>
        <Typography variant="h4" gutterBottom>
          Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your organization settings and preferences
        </Typography>
      </Box>

      <Box className={contentStyles}>
        <BusinessHours />
        <LocationClosures />
      </Box>
    </Container>
  );
};

const headerStyles = css`
  margin-bottom: 2rem;
`;

const contentStyles = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export default SettingsPage;
